import { Moon, Sun } from "lucide-react";
import { useTema } from "@/lib/tema";

/* Botón luna/sol + selector explícito «Claro (blanco)» / «Oscuro». Siempre habilitado: es una preferencia personal, sin permiso. */
export default function BotonTema({ className = "" }) {
  const [tema, alternar, elegir] = useTema();
  const oscuro = tema === "oscuro";
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="tema-control">
      <button type="button" onClick={alternar} data-testid="boton-tema" aria-label={oscuro ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
        title={oscuro ? "Tema claro (blanco)" : "Tema oscuro"}
        className="relative h-9 w-9 grid place-items-center rounded-lg border border-slate-300 bg-white text-slate-600 transition-[transform,color] duration-150 ease-[var(--ease-out)] active:scale-[0.94] hover:text-emerald-700">
        <Sun className={`h-[18px] w-[18px] absolute transition-[opacity,transform] duration-300 ease-[var(--ease-out)] ${oscuro ? "opacity-0 rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"}`} />
        <Moon className={`h-[18px] w-[18px] absolute transition-[opacity,transform] duration-300 ease-[var(--ease-out)] ${oscuro ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-50"}`} />
      </button>
      <select value={tema} onChange={(e) => elegir(e.target.value)} aria-label="Color de la pantalla" data-testid="selector-tema"
        className="h-9 rounded-lg border border-slate-300 bg-white px-2 text-xs text-slate-700">
        <option value="claro">Claro (blanco)</option>
        <option value="oscuro">Oscuro</option>
      </select>
    </div>
  );
}
